import "@/styles/globals.css";
import "react-toastify/dist/ReactToastify.css";
import { Inter, Montserrat, Poppins } from "next/font/google";
import { Slide, ToastContainer } from "react-toastify";
import { appWithTranslation } from "next-i18next";
import NextNProgress from "nextjs-progressbar";
import usePageViewTracking from "@/utils/usePageViewTracking";
import Head from "next/head";
import { META_IMAGE } from "@/utils/meta";
import WhatsAppButton from "@/components/shared/WhatsappButton";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { captureUtmParams } from "@/utils/utm";

const montserrat = Montserrat({
  subsets: ["latin"],
  display: "swap",
  variable: "--font-montserrat",
});

const inter = Inter({
  subsets: ["latin"],
  display: "swap",
  variable: "--font-inter",
});

const poppins = Poppins({
  subsets: ["latin"],
  display: "swap",
  variable: "--font-poppins",
  weight: ["400", "500", "600", "700"],
});

const App = ({ Component, pageProps }) => {
  usePageViewTracking();
  const router = useRouter();

  useEffect(() => {
    captureUtmParams();
  }, [router.asPath]);

  return (
    <main className={`${inter.variable} ${montserrat.variable} ${poppins.variable} ${montserrat.className}`}>
      <Head>
        <meta property="og:image" content={META_IMAGE} />
      </Head>
      <NextNProgress
        color="#FE3D67"
        height={5}
        options={{ showSpinner: false }}
      />
      <Component {...pageProps} />
      {/* <WhatsAppButton /> */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        theme="dark"
        transition={Slide}
        hideProgressBar
        closeOnClick
        pauseOnHover
      />
    </main>
  );
};

export default appWithTranslation(App);
